import { render, staticRenderFns } from "./zhp.vue?vue&type=template&id=0f8b10b2&scoped=true&"
import script from "./zhp.vue?vue&type=script&lang=ts&"
export * from "./zhp.vue?vue&type=script&lang=ts&"
import style0 from "./zhp.vue?vue&type=style&index=0&id=0f8b10b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b10b2",
  null
  
)

export default component.exports